import React from "react";
import { motion } from "framer-motion";
import AppWrap from "../../wrapper/AppWrap";

const brands = [
  {
    imageUrl: "https://www.vibely.life/vibely.png",
    name: "Vibely",
    url: "https://www.vibely.life/",
  },
  {
    imageUrl: "https://www.hyperce.io/og-logo.png",
    name: "Hyperce",
    url: "https://www.hyperce.io/",
  },
  {
    imageUrl: "https://www.pahunahomes.com/images/logo.svg",
    name: "PahunaHomes",
    url: "https://www.pahunahomes.com",
  },
  {
    imageUrl: "https://kadamstore.netlify.app/static/media/logo.5999575980d51bc4ac0b.png",
    name: "Kadam Fitness",
    url: "https://www.facebook.com/kadamfitness/",
  },
  {
    imageUrl: "https://png.pngtree.com/png-vector/20220820/ourmid/pngtree-transparent-order-now-png-png-image_6117014.png",
    name: "Order now",
    url: "https://ordernow.com.np/",
  },
  {
    imageUrl: "https://www.uploadvr.com/content/images/2021/02/PS5-VR.png",
    name: "Ns3 Vr Arcade",
    url: "https://www.facebook.com/profile.php?id=100083267560993",
  },
  {
    imageUrl: "https://renewalhub.com.np/static/images/about.jpg",
    name: "Renewal Hub",
    url: "https://renewalhub.com.np/",
  },
];

const Testimonial = () => {
  return (
    <section className="space-y-8">
      <div className="flex flex-col gap-2">
        <p className="text-sm uppercase tracking-[0.3em] text-primary">Partners & collaborators</p>
        <h2 className="text-3xl sm:text-4xl font-bold text-white">Trusted by teams that move fast.</h2>
        <p className="text-slate-300 max-w-3xl">
          Startups, studios, and founders across industries rely on me to ship confidently and keep momentum high.
        </p>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4"
      >
        {brands.map((brand) => (
          <a
            href={brand.url}
            key={brand.name}
            target="_blank"
            rel="noopener noreferrer"
            className="group rounded-2xl border border-white/10 bg-white/5 backdrop-blur px-4 py-3 flex items-center justify-center h-24 shadow-2xl hover:border-white/25 transition-colors"
          >
            <motion.img
              src={brand.imageUrl}
              alt={brand.name}
              whileHover={{ scale: 1.05 }}
              className="object-contain max-h-14 max-w-[140px] grayscale group-hover:grayscale-0 transition-all"
            />
          </a>
        ))}
      </motion.div>
    </section>
  );
};

export default AppWrap(Testimonial, "testimonials");
